
/**
 * @group Renderer
 */
export const OISVGRendererConst =
{
  arrowHeadStartMarker: "arrow-head-start",
  arrowHeadEndMaker: "arrow-head-end",
  selectionFilterId: "selection-filter",
  removalFilterId: "removal-filter",
  crossMarker: "cross-marker",
  noSelection: "pointer-events: none; -webkit-touch-callout: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none;",
}
